export const getGeolocationErrorMessage = (
  error: Error,
  t: (key: string) => string,
): string => {
  return t(`contractorVisits.error.geolocation.${error.message}`);
};
